import React, { useState, useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import DIETLogo from "../PIC/Logo/DIET_Logo.png";
import ACMLogo from "../PIC/Logo/DIET_ACM_Logo.png";
import "./Header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isBlogsPageActive = location.pathname.startsWith("/blogs");
  const isEventsPageActive = location.pathname.startsWith("/events");
  const isOurTeamPageActive = location.pathname.startsWith("/ourteam");
  const isGalleryPageActive = location.pathname.startsWith("/gallery");
  const isBenefitsPageActive = location.pathname.startsWith("/benefits");
  const isCalendarPageActive = location.pathname.startsWith("/calendar");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock background scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMenuOpen]);

  const onNavClick = () => {
    setIsMenuOpen(false);
  };

  const navItems = [
    { key: "home", label: "Home", path: "/" },
    { key: "blogs", label: "Blogs", path: "/blogs" },
    { key: "events", label: "Events", path: "/events" },
    { key: "calendar", label: "Calendar", path: "/calendar" },
    { key: "ourteam", label: "Team", path: "/ourteam" },
    { key: "gallery", label: "Gallery", path: "/gallery" },
    { key: "benefits", label: "Benefits", path: "/benefits" },
  ];

  return (
    <>
      <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-inner">
          {/* Brand Logo Container */}
          <div className="logo-container">
            <a
              href="https://diet.edu.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
              title="Dadi Institute of Engineering & Technology"
            >
              <img src={DIETLogo} alt="DIET Logo" className="diet-logo" />
            </a>
            <div className="logo-divider"></div>
            <RouterLink
              to="/"
              className="logo-link"
              onClick={() => {
                onNavClick();
                scroll.scrollToTop();
              }}
              title="DIET ACM Student Chapter"
            >
              <img src={ACMLogo} alt="ACM Logo" className="acm-logo" />
            </RouterLink>
          </div>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            {navItems.map((item) => {
              const isHomeActive =
                item.key === "home" &&
                location.pathname === "/" &&
                !isBlogsPageActive &&
                !isEventsPageActive &&
                !isCalendarPageActive &&
                !isOurTeamPageActive &&
                !isGalleryPageActive &&
                !isBenefitsPageActive;

              const isItemActive =
                (item.key === "blogs" && isBlogsPageActive) ||
                (item.key === "events" && isEventsPageActive) ||
                (item.key === "calendar" && isCalendarPageActive) ||
                (item.key === "ourteam" && isOurTeamPageActive) ||
                (item.key === "gallery" && isGalleryPageActive) ||
                (item.key === "benefits" && isBenefitsPageActive);

              const active = isHomeActive || isItemActive;

              return (
                <RouterLink
                  key={item.key}
                  to={item.path}
                  className={`nav-link ${active ? "active" : ""}`}
                  onClick={onNavClick}
                >
                  <span>{item.label}</span>
                  {active && <span className="nav-glow-pill"></span>}
                </RouterLink>
              );
            })}
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            className={`menu-button ${isMenuOpen ? "open" : ""}`}
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-label="Toggle Navigation Menu"
            aria-expanded={isMenuOpen}
          >
            <span className="bar bar-1"></span>
            <span className="bar bar-2"></span>
            <span className="bar bar-3"></span>
          </button>
        </div>
      </header>

      {/* Mobile Drawer Overlay */}
      <div
        className={`mobile-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={() => setIsMenuOpen(false)}
      ></div>

      {/* Mobile Drawer Navigation */}
      <aside className={`mobile-drawer ${isMenuOpen ? "open" : ""}`}>
        <div className="mobile-drawer-header">
          <div className="mobile-drawer-brand">
            <img src={ACMLogo} alt="ACM Logo" className="drawer-acm-logo" />
            <span>DIET ACM</span>
          </div>
          <button
            className="drawer-close-btn"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close Menu"
          >
            &times;
          </button>
        </div>

        <nav className="mobile-nav-list">
          {navItems.map((item) => {
            const isHomeActive =
              item.key === "home" &&
              location.pathname === "/" &&
              !isBlogsPageActive &&
              !isEventsPageActive &&
              !isCalendarPageActive &&
              !isOurTeamPageActive &&
              !isGalleryPageActive &&
              !isBenefitsPageActive;

            const isItemActive =
              (item.key === "blogs" && isBlogsPageActive) ||
              (item.key === "events" && isEventsPageActive) ||
              (item.key === "calendar" && isCalendarPageActive) ||
              (item.key === "ourteam" && isOurTeamPageActive) ||
              (item.key === "gallery" && isGalleryPageActive) ||
              (item.key === "benefits" && isBenefitsPageActive);

            const active = isHomeActive || isItemActive;

            return (
              <RouterLink
                key={item.key}
                to={item.path}
                className={`mobile-nav-item ${active ? "active" : ""}`}
                onClick={onNavClick}
              >
                <span>{item.label}</span>
                <i className="fas fa-chevron-right mobile-arrow"></i>
              </RouterLink>
            );
          })}
        </nav>
      </aside>
    </>
  );
}

export default Header;